import React from 'react';

interface IErrorHandlerProps {
  children: JSX.Element;
  fallbackClassName?: string;
  onError?: () => void;
  pageNotFound?: boolean;
}

interface IErrorHandlerState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<IErrorHandlerProps, IErrorHandlerState> {
  constructor(props: IErrorHandlerProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error', this.props.fallbackClassName, error, errorInfo);
    this.props?.onError?.();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <></>;
    }

    return this.props.children;
  }
}
